const allSuppliers = {
  icon: true,
  id: true,
  plugin_name: true,
  type: true,
  comments: true,
};

export { allSuppliers };